import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import AdminSidebar from "../AdminSidebar/AdminSidebar";

import classes from "./AdminContent.module.scss";
import { useSelector } from "react-redux";

const AdminDashboardContentWrapper = (props) => {
  const isSidebarOpen = useSelector(state => state.layoutReducer.isSidebarOpen)
  const [tempClass, setTempClass] = useState("content-body");

  useEffect(() => {
    console.log(isSidebarOpen);
    if (isSidebarOpen) setTempClass('content-body')
    else setTempClass('content-body-expanded')
  }, [isSidebarOpen]);

  return (
    <div className="main-content">
      <AdminSidebar />
      <div style={{ padding: "20px" }} className={tempClass}>
        {props.children}
      </div>
    </div>
  );
};

export default AdminDashboardContentWrapper;
